import { motion } from "framer-motion";
import { Tag, Headset, Compass, ShieldCheck } from "@phosphor-icons/react";

const ITEMS = [
    { icon: Tag, title: "Best Price Promise", text: "Transparent pricing with exclusive partner rates. If you find it cheaper, we match it." },
    { icon: Headset, title: "24/7 Concierge", text: "Real humans on call across time zones — from missed trains to midnight cravings." },
    { icon: Compass, title: "Expert Local Guides", text: "Hand-picked guides who live where they teach. Access, stories, and shortcuts." },
    { icon: ShieldCheck, title: "Safe & Insured", text: "IATA-affiliated, fully insured, and vetted partners only. Travel with peace of mind." },
];

export default function WhyChooseUs() {
    return (
        <section className="relative py-24 lg:py-32 bg-navy" data-testid="why-choose-us">
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
                <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
                    <div className="lg:col-span-7">
                        <p className="overline">Why Midasis</p>
                        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium mt-4 leading-tight">
                            A quiet confidence you feel <em className="italic text-gold">from the first call.</em>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 font-sans text-base text-white/65 leading-relaxed">
                        We don't sell trips — we design them. Every itinerary is personal,
                        every partner is vetted, and every traveler is cared for like family.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
                    {ITEMS.map((it, i) => {
                        const Icon = it.icon;
                        return (
                            <motion.div
                                key={it.title}
                                initial={{ opacity: 0, y: 18 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{ duration: 0.6, delay: i * 0.08 }}
                                className="p-8 lg:p-10 border-r border-b border-white/10 group hover:bg-white/[0.02] transition-colors duration-500"
                                data-testid={`why-item-${i}`}
                            >
                                <Icon size={36} weight="light" className="text-gold" />
                                <h3 className="font-serif text-2xl mt-6">{it.title}</h3>
                                <p className="font-sans text-sm text-white/60 mt-3 leading-relaxed">{it.text}</p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
